import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
export const LazyImage = ({ src, srcSet, alt = '', className = '', threshold = 100, fallback: Fallback = null, onError = null, afterLoad, visibleByDefault = false, }) => {
    const [showFallback, setShowFallback] = useState(false);
    const handleError = () => {
        setShowFallback(true);
        onError && onError();
    };
    const handleAfterLoad = () => {
        afterLoad && afterLoad();
    };
    return Fallback && showFallback ? (_jsx(Fallback, {}, void 0)) : (_jsx(LazyLoadImage, { afterLoad: handleAfterLoad, alt: alt, className: className, delayTime: 50, draggable: false, effect: "opacity", onError: handleError, src: src, srcSet: srcSet, threshold: threshold, visibleByDefault: visibleByDefault }, void 0));
};
//# sourceMappingURL=LazyImage.js.map